import { render, staticRenderFns } from "./AmountOfChangeTemplate.vue?vue&type=template&id=76eceae8&scoped=true&"
import script from "./AmountOfChangeTemplate.vue?vue&type=script&lang=js&"
export * from "./AmountOfChangeTemplate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76eceae8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/build/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('76eceae8')) {
      api.createRecord('76eceae8', component.options)
    } else {
      api.reload('76eceae8', component.options)
    }
    module.hot.accept("./AmountOfChangeTemplate.vue?vue&type=template&id=76eceae8&scoped=true&", function () {
      api.rerender('76eceae8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Papers/pages/Paper/components/Templates/AmountOfChangeTemplate.vue"
export default component.exports